import { Redirect, Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import { Task } from "../../store/viewmodels/TaskViewModel";
import { getNextItemSetId } from "../../utils/TaskNavigationServices";
import StudentItemset from "./StudentItemset";
import { useAppSelector } from "../../store/Hooks";


interface StudentTaskParams {
    taskId: string
}

function StudentTask() {
    let { taskId } = useParams<StudentTaskParams>();
    const studentData = useAppSelector(state => state.studentData);
    const studentTasks = studentData.student.task_access_list;
    const studentItemsets = studentData.student.active_item_sets;

    const task: Task | undefined = studentTasks.find(task => task.id.toString() === taskId);
    let { path, url } = useRouteMatch();
    if (!task || task.id.toString().length === 0) {
        return (
            <h1 className="text-3xl font-bold leading-tight text-gray-900">Tehtävää ei löytynyt.</h1>
        );
    }

    let nextItemsetId: string = getNextItemSetId(task, "", studentItemsets);
    let redirect = nextItemsetId.length > 0 ? <Redirect to={`${url}/itemsets/${nextItemsetId}`} /> : <Redirect to="/student/tasks" />;

    return (
        <Switch>
            <Route exact path={path}>
                {redirect}
            </Route>
            <Route path={`${path}/itemsets/:itemsetId`}>
                    <StudentItemset task={task} />
            </Route>
        </Switch>
    );
}


export default StudentTask;
